export const followActionType = {
    FOLLOWERS_LOADING_START: "FOLLOWERS_LOADING_START",
    FOLLOWERS_LOADING_SUCCESS: "FOLLOWERS_LOADING_SUCCESS",
    FOLLOWERS_LOADING_ERROR: "FOLLOWERS_LOADING_ERROR",
    FOLLOWING_LOADING_START: "FOLLOWING_LOADING_START",
    FOLLOWING_LOADING_SUCCESS: "FOLLOWING_LOADING_SUCCESS",
    FOLLOWING_LOADING_ERROR: "FOLLOWING_LOADING_ERROR",
    FOLLOW_START: "FOLLOW_START",
    FOLLOW_SUCCESS: "FOLLOW_SUCCESS",
    FOLLOW_ERROR: "FOLLOW_ERROR",
}